import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { CompanyService } from '../../features/services/company.service';
import { Observable, of, switchMap } from 'rxjs';
import { VerificationStatusEnum } from '../../common/enums/verification-status.enum';
import { ThreeButtonDialogService } from '../../features/services/three.button.dialog.service';

export const preNavigationGuard: CanActivateFn = () => {

  const confirmationService = inject(ConfirmationService);
  const companyService = inject(CompanyService);
  const companyId = sessionStorage.getItem('companyId')?.toString() || '';
  const router = inject(Router);
  const dialog = inject(ThreeButtonDialogService);
  
  return companyService.getW9(companyId).pipe(

    switchMap(d => {

      //CASE 1: No W9 → keep existing logic
      if (d === null) {

    return new Observable<boolean>((observer) => {

        dialog.open({

            header: 'Before You Begin:',

            message: 'To complete voucher setup, you’ll need to upload your business or organization’s IRS Form W-9 for business verification. If you’re not ready with this document, please return when you have it available.',

            leftButton: 'Cancel',

            middleButton: 'Start Business Verification',

            rightButton: 'Continue'

        }).then(result => {

            switch (result) {

                case 'cancel':

                    observer.next(false);
                    observer.complete();
                    break;

                case 'middle':

                    router.navigate(['/w9-business-verification']);

                    observer.next(false);
                    observer.complete();
                    break;

                case 'continue':

                    observer.next(true);
                    observer.complete();
                    break;
            }

        });

    });

}
      
      const status = Number(d.verificationStatus);

      // CASE 2: W9 exists + Pending → NEW BLOCK
      if (status === VerificationStatusEnum.Pending) {
        return new Observable<boolean>((observer) => {

          confirmationService.confirm({
            message: 'You\'re business verification is under way! As soon as your account is approved, we\'ll send you a follow-up email and you can start your Employee Voucher Program.',
            header: 'Business Verification Pending',
            acceptLabel: 'Continue',
            rejectLabel: 'Cancel',

            accept: () => {                      
              observer.next(true);
              observer.complete();
            },

            reject: () => {
              observer.next(false);
              observer.complete();
            }
          });

        });
      }

      // CASE 3: W9 exists + Rejected → NEW BLOCK
      if (status === VerificationStatusEnum.Rejected) {
        return new Observable<boolean>((observer) => {

          confirmationService.confirm({
            message: 'Business rejected, reupload business to start a second voucher program.',
            header: 'Business Rejected',
            acceptLabel: 'View Status',
            rejectLabel: 'Close',

            accept: () => {             
              router.navigate(['/account-settings']);
              observer.next(false);
              observer.complete();
            },

            reject: () => {
              observer.next(false);
              observer.complete();
            }
          });

        });
      }

      // //CASE 4: Approved → allow
      // if (status === VerificationStatusEnum.Approved) {
      //   return of(true);
      // }

      // fallback (keep safe)
      return of(true);
    })
  );
};